import React from "react";
import { useIntl } from "react-intl";

const TabInfo = () => {
  const { messages } = useIntl();
  return (
    <div
      style={{
        background: "#ecf4f9",
        width: "99%",
        color: "#1083B8",
        padding: "5px",
        borderRadius: "3px",
        alignItems: "center",
        display: "flex",
        fontSize: '13px'
      }}
    >
  
      <span style={{fontSize: '24px'}} className="material-icons">info</span>
      <div style={{ width: "90%", display: "flex", justifyContent: "center" }}>
        {messages["videoMainView_alertMessage"]}
      </div>
    </div>
  );
};

export default TabInfo;
